export const isEmpty = <T>(obj: T): boolean => {
  if (!obj) return true;
  return Object.keys(obj).length === 0;
};
